import { useMutation } from '@apollo/client';
import {
  SET_BUSINESS_FUNCTION_IT_APP_COMMENT,
  SET_LOCATION_BUSINESS_FUNCTION_IT_APP_COMMENT,
} from '../../pages/dataInputs/queries/itApplications';
import { UpdateCommentResponse, UpdateCommentVariables } from './types';

/**
 * Hook to update IT application comments for enterprise business functions
 * @returns updateComment - Function to update IT application comments
 */
export const useUpdateITApplicationComment = () => {
  const [mutate] = useMutation<UpdateCommentResponse, UpdateCommentVariables>(
    SET_BUSINESS_FUNCTION_IT_APP_COMMENT,
    {
      refetchQueries: ['GetBusinessFunctionsSelectedItApplications'],
    },
  );

  const updateComment = async (options: {
    variables: UpdateCommentVariables;
  }) => {
    const result = await mutate(options);
    return {
      data: result.data || {
        setBusinessFunctionItAppComment: { success: false },
      },
    };
  };

  return updateComment;
};

/**
 * Hook to update IT application comments for location business functions
 * @returns updateComment - Function to update IT application comments
 */
export const useUpdateLocationITApplicationComment = () => {
  const [mutate] = useMutation<UpdateCommentResponse, UpdateCommentVariables>(
    SET_LOCATION_BUSINESS_FUNCTION_IT_APP_COMMENT,
    {
      refetchQueries: ['GetLocationBusinessFunctionsSelectedItApplications'],
    },
  );
  const updateComment = async (options: {
    variables: UpdateCommentVariables;
  }) => {
    const result = await mutate(options);
    return {
      data: result.data || {
        setLocationBusinessFunctionMappingComment: { success: false },
      },
    };
  };

  return updateComment;
};
